import type {ReactElement} from 'react';
import {useContext} from 'react';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';
import {Plural, Trans} from '@lingui/macro';
import styles from './balanceBlock.module.scss';
import {Link} from 'react-router-dom';
import {store} from '@context/balance';
import {clsx} from 'clsx';

export default function BalanceBlock(): ReactElement {
    const {currentState} = useContext(store);
    const query = useQueryWithAuth({queryKey: ['me'], queryFn: me});

    function getPagesCount(): string | number {
        if (query.isLoading) {
            return '...';
        }

        if (query.isError) {
            return '???';
        }

        return query.data.data.pagesRemaining;
    }

    const classNames = clsx([
        styles.balance,
        {[styles.balanceUpdating]: currentState.isUpdating || query.isLoading || query.isFetching},
    ]);
    const pagesRemaining = getPagesCount();

    return (
        <div className={styles.root}>
            <Trans>Your balance:</Trans>{' '}
            <Plural context="page header" value={pagesRemaining} one="# page" other="# pages" />
            <Link className={styles.balanceLink} to="/topup">
                <span className={classNames}>
                    <Trans>Top up</Trans>
                </span>
            </Link>
        </div>
    );
}
